/**
 * Utility methods to work around the fact that the ID scan API expects the first name and last name to be separate
 * attributes, while invites & entries only contain a a full name.
 * For the sake of simplicitly and for the initial launch of the ID scanning feature in invite-sign, this is done
 * in the most naìve (and wrong) way - the full name is split at the first space and anything before that is treated
 * as a first name, while anything after is treated as a last name.
 *
 * The kiosk uses Apple's `PersonNameComponentsFormatter` (https://developer.apple.com/documentation/foundation/personnamecomponentsformatter)
 * to handle separating first and last names.
 *
 * In the future we should explore JS libraries that offer a better experience than these simple-but-wrong functions.
 */
export function firstName(fullName: string): string {
  return extractFirstAndLastName(fullName).firstName;
}

export function lastName(fullName: string): string {
  return extractFirstAndLastName(fullName).lastName;
}

function extractFirstAndLastName(fullName: string): { firstName: string; lastName: string } {
  const matches = fullName.match(/^(.+?)\s+(.+)$/);
  if (matches) {
    return { firstName: matches[1]!, lastName: matches[2]! };
  } else {
    return { firstName: fullName, lastName: '' };
  }
}
